/**
 * Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com).
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import {Platform} from '@asgardeo/browser';
import {FC} from 'react';
import BaseSignUpV1, {BaseSignUpProps as BaseSignUpV1Props} from './v1/BaseSignUp';
import BaseSignUpV2, {BaseSignUpProps as BaseSignUpV2Props} from './v2/BaseSignUp';
import useAsgardeo from '../../../../contexts/Asgardeo/useAsgardeo';

/**
 * Props for the BaseSignUp component.
 * Extends BaseSignUpV1Props & BaseSignUpV2Props for full compatibility with both React BaseSignUp components.
 */
export type BaseSignUpProps = BaseSignUpV1Props | BaseSignUpV2Props;

const BaseSignUp: FC<BaseSignUpProps> = (props: BaseSignUpProps) => {
  const {platform} = useAsgardeo();

  if (platform === Platform.AsgardeoV2) {
    return <BaseSignUpV2 {...(props as BaseSignUpV2Props)} />;
  }

  return <BaseSignUpV1 {...(props as BaseSignUpV1Props)} />;
};

export default BaseSignUp;
